import { baseApi } from 'api/base';
import { ElkEpguRequestInfoDTO } from './types';

const getDpoRequestInfo = async (id: string): Promise<ElkEpguRequestInfoDTO> => {
  const res = await baseApi.get(`/epgu/information/confirming-document/${id}`);
  return res.data;
};
const getDpoRecRequestInfo = async (id: string): Promise<ElkEpguRequestInfoDTO> => {
  const res = await baseApi.get(`/rec/information/confirming-document/${id}`);
  return res.data;
};

const getGmpRequestInfo = async (id: string): Promise<ElkEpguRequestInfoDTO> => {
  const res = await baseApi.get(`/epgu/information/gmp/${id}`);
  return res.data;
};

const getFeedRequestInfo = async (id: string): Promise<ElkEpguRequestInfoDTO> => {
  const res = await baseApi.get(`/epgu/information/feed-additive/${id}`);
  return res.data;
};

const getGmoRequestInfo = async (id: string): Promise<ElkEpguRequestInfoDTO> => {
  const res = await baseApi.get(`/epgu/information/gmo/${id}`);
  return res.data;
};

const getGmProductRequestInfo = async (id: string): Promise<ElkEpguRequestInfoDTO> => {
  const res = await baseApi.get(`/epgu/information/gm-product/${id}`);
  return res.data;
};

const getPharmPermRequestInfo = async (id: string): Promise<ElkEpguRequestInfoDTO> => {
  const res = await baseApi.get(`/epgu/information/pharm-permission/${id}`);
  return res.data;
};

const registerDpo = async (id: string, requestTypeId?: string) => {
  await baseApi.post(`/epgu/registration/confirming-document/${id}?requestTypeId=${requestTypeId}`);
};

const registerDpoRec = async (id: string, requestTypeId?: string) => {
  await baseApi.post(`/rec/registration/confirming-document/${id}?requestTypeId=${requestTypeId}`);
};

const registerGmp = async (id: string, requestTypeId?: string) => {
  await baseApi.post(`/epgu/registration/gmp/${id}?requestTypeId=${requestTypeId}`);
};

const registerFeed = async (id: string, requestTypeId?: string) => {
  await baseApi.post(`/epgu/registration/feed-additive/${id}?requestTypeId=${requestTypeId}`);
};

const registerGmo = async (id: string, requestTypeId?: string) => {
  await baseApi.post(`/epgu/registration/gmo/${id}?requestTypeId=${requestTypeId}`);
};

const registerGmProduct = async (id: string, requestTypeId?: string) => {
  await baseApi.post(`/epgu/registration/gm-product/${id}?requestTypeId=${requestTypeId}`);
};

const registerPharmPerm = async (id: string, requestTypeId?: string) => {
  await baseApi.post(`/epgu/registration/pharm-permission/${id}?requestTypeId=${requestTypeId}`);
};

export const elkEpguApi = {
  getDpoRequestInfo,
  getDpoRecRequestInfo,
  getGmpRequestInfo,
  getFeedRequestInfo,
  getGmoRequestInfo,
  getGmProductRequestInfo,
  getPharmPermRequestInfo,
  registerDpo,
  registerDpoRec,
  registerGmp,
  registerFeed,
  registerGmo,
  registerGmProduct,
  registerPharmPerm,
};
